(function(){
var K='lb_favs';
function read(){try{return JSON.parse(localStorage.getItem(K))||[]}catch(e){return[]}}
function write(a){try{localStorage.setItem(K,JSON.stringify(a))}catch(e){}}
function has(h){return read().indexOf(h)>-1}
function toggle(h){var a=read(),i=a.indexOf(h);if(i>-1){a.splice(i,1)}else{a.push(h)}write(a);counts();return i<0}
var HEART='<svg viewBox="0 0 24 24" aria-hidden="true"><path d="M12 20.4C8.6 18 4.5 14.8 4.5 11.2 4.5 9 6.2 7.3 8.4 7.3c1.5 0 2.8.8 3.6 2 .8-1.2 2.1-2 3.6-2 2.2 0 3.9 1.7 3.9 3.9 0 3.6-4.1 6.8-7.5 9.2z"/></svg>';
var SHARE='<svg viewBox="0 0 24 24" aria-hidden="true"><circle cx="18" cy="5" r="2.6"/><circle cx="6" cy="12" r="2.6"/><circle cx="18" cy="19" r="2.6"/><path d="M8.3 10.8l7.4-4.3M8.3 13.2l7.4 4.3"/></svg>';
function counts(){var n=read().length;document.querySelectorAll('.lb-favcount').forEach(function(e){e.textContent=n;e.style.display=n?'':'none'})}
function sync(h,on){document.querySelectorAll('[data-fav-handle="'+h+'"]').forEach(function(x){x.setAttribute('aria-pressed',on?'true':'false')})}
document.addEventListener('click',function(e){var b=e.target.closest&&e.target.closest('[data-fav-handle]');if(!b)return;e.preventDefault();e.stopPropagation();var h=b.getAttribute('data-fav-handle');sync(h,toggle(h))},true);
function mkHeart(h){var b=document.createElement('button');b.type='button';b.className='lb-fav';b.setAttribute('data-fav-handle',h);b.setAttribute('aria-pressed',has(h)?'true':'false');b.setAttribute('aria-label','Save to favorites');b.innerHTML=HEART;return b}
function handleOf(card){var a=card.querySelector('a[href*="/products/"]');if(!a)return null;var m=a.getAttribute('href').match(/\/products\/([^/?#]+)/);return m?m[1]:null}
function injectHearts(){
 document.querySelectorAll('product-card, .product-card, .product-grid__item, .card--product').forEach(function(card){
  if(card.querySelector(':scope > .lb-fav'))return;
  if(card.closest('.lb-pcard-wrap'))return;
  var h=handleOf(card);if(!h)return;
  var host=card.querySelector('.card-gallery')||card.querySelector('.product-media-container')||card;
  if(host.querySelector(':scope > .lb-fav'))return;
  if(getComputedStyle(host).position==='static'){host.style.position='relative'}
  host.appendChild(mkHeart(h));
 });
 document.querySelectorAll('[data-fav-handle]').forEach(function(b){b.setAttribute('aria-pressed',has(b.getAttribute('data-fav-handle'))?'true':'false')});
 counts();
}
window.LBFav={read:read,has:has,HEART:HEART,inject:injectHearts};
function pdpHandle(){var m=location.pathname.match(/\/products\/([^/?#]+)/);return m?m[1]:null}
function shareBtn(){var b=document.createElement('button');b.type='button';b.className='lb-share';b.innerHTML=SHARE+'<span>Share</span>';b.addEventListener('click',function(){var d={title:document.title,url:location.href.split('?')[0]};if(navigator.share){navigator.share(d).catch(function(){})}else if(navigator.clipboard){navigator.clipboard.writeText(d.url).then(function(){b.classList.add('lb-share--done');b.querySelector('span').textContent='Link copied';setTimeout(function(){b.classList.remove('lb-share--done');b.querySelector('span').textContent='Share'},2200)})}});return b}
function favBtn(h){var b=mkHeart(h);b.className='lb-fav lb-fav--pdp';b.innerHTML=HEART+'<span>Save</span>';return b}
function mount(){
 injectHearts();
 var h=pdpHandle();
 if(h&&!document.querySelector('.lb-actionrow')){
  var form=document.querySelector('form[action*="/cart/add"]');
  if(form&&form.parentElement){var r=document.createElement('div');r.className='lb-actionrow';r.appendChild(favBtn(h));r.appendChild(shareBtn());form.parentElement.appendChild(r)}
 }
 if(/\/blogs\//.test(location.pathname)&&!document.querySelector('.lb-actionrow')){
  var art=document.querySelector('article')||document.querySelector('main');
  if(art){var r2=document.createElement('div');r2.className='lb-actionrow';r2.appendChild(shareBtn());art.appendChild(r2)}
 }
}
if(document.readyState!=='loading'){mount()}else{document.addEventListener('DOMContentLoaded',mount)}
document.addEventListener('shopify:section:load',mount);
var mo=new MutationObserver(function(){clearTimeout(window.__lbT);window.__lbT=setTimeout(injectHearts,200)});
document.addEventListener('DOMContentLoaded',function(){mo.observe(document.body,{childList:true,subtree:true})});
})();
(function(){
var C=['#b84420','#e0a33a','#2f6f55','#202f2c','#f4f2ec'];
var last=0;
function burst(){
 var now=Date.now();if(now-last<800)return;last=now;
 var cv=document.getElementById('lb-confetti');
 if(!cv){cv=document.createElement('canvas');cv.id='lb-confetti';document.body.appendChild(cv)}
 var dpr=Math.min(window.devicePixelRatio||1,2);
 cv.width=innerWidth*dpr;cv.height=innerHeight*dpr;cv.style.width=innerWidth+'px';cv.style.height=innerHeight+'px';
 var x=cv.getContext('2d');x.setTransform(dpr,0,0,dpr,0,0);
 var reduce=matchMedia('(prefers-reduced-motion: reduce)').matches;
 var n=reduce?30:110,p=[];
 for(var i=0;i<n;i++){p.push({x:innerWidth/2+(Math.random()-0.5)*160,y:innerHeight*0.32,vx:(Math.random()-0.5)*9,vy:-6-Math.random()*8,w:5+Math.random()*6,h:8+Math.random()*7,r:Math.random()*Math.PI,vr:(Math.random()-0.5)*0.3,c:C[(Math.random()*C.length)|0],life:0})}
 var t0=performance.now();
 function frame(t){
  var dt=Math.min((t-t0)/16.7,3);t0=t;
  x.clearRect(0,0,innerWidth,innerHeight);
  var alive=0;
  for(var i=0;i<p.length;i++){var o=p[i];o.life+=dt;o.vy+=0.28*dt;o.vx*=0.995;o.x+=o.vx*dt;o.y+=o.vy*dt;o.r+=o.vr*dt;
   if(o.y<innerHeight+40){alive++;x.save();x.translate(o.x,o.y);x.rotate(o.r);x.globalAlpha=Math.max(0,1-o.life/150);x.fillStyle=o.c;x.fillRect(-o.w/2,-o.h/2,o.w,o.h);x.restore()}}
  if(alive>0){requestAnimationFrame(frame)}else{x.clearRect(0,0,innerWidth,innerHeight);if(cv.parentNode)cv.parentNode.removeChild(cv)}
 }
 requestAnimationFrame(frame);
}
window.LBConfetti=burst;
var count=null;
function readCount(cb){fetch('/cart.js',{headers:{Accept:'application/json'}}).then(function(r){return r.json()}).then(function(c){cb(c.item_count)}).catch(function(){})}
readCount(function(n){count=n});
function checkCart(){readCount(function(n){if(count===null){count=n;return}if(n>count){burst()}count=n})}
window.LBCartCheck=checkCart;
var od=EventTarget.prototype.dispatchEvent;
EventTarget.prototype.dispatchEvent=function(ev){
 try{if(ev&&typeof ev.type==='string'){if(/^cart[:_-]?(add|added)/i.test(ev.type)){setTimeout(burst,40)}else if(/^cart[:_-]?update/i.test(ev.type)){setTimeout(checkCart,120)}}}catch(e){}
 return od.apply(this,arguments);
};
var of=window.fetch;
window.fetch=function(){
 var u=arguments[0];var url=typeof u==='string'?u:(u&&u.url)||'';
 var pr=of.apply(this,arguments);
 try{if(/\/cart\/add/.test(url)){pr.then(function(r){if(r&&r.ok){setTimeout(burst,40)}}).catch(function(){})}}catch(e){}
 return pr;
};
var os=XMLHttpRequest.prototype.open;
XMLHttpRequest.prototype.open=function(m,u){this.__lbu=u;return os.apply(this,arguments)};
var osend=XMLHttpRequest.prototype.send;
XMLHttpRequest.prototype.send=function(){var self=this;this.addEventListener('load',function(){if(/\/cart\/add/.test(self.__lbu||'')&&self.status<400){setTimeout(burst,40)}});return osend.apply(this,arguments)};
})();
(function(){
function bubble(n){
 var c=document.querySelector('.cart-bubble__text-count');
 if(c){c.textContent=n;c.classList.remove('hidden')}
 var b=document.querySelector('.cart-bubble');
 if(b){b.classList.remove('visually-hidden')}
}
function refresh(){fetch('/cart.js',{headers:{'Accept':'application/json'}}).then(function(r){return r.json()}).then(function(c){bubble(c.item_count)}).catch(function(){})}
document.addEventListener('click',function(e){
 var b=e.target.closest&&e.target.closest('.lb-add[data-vid]');
 if(!b)return;
 e.preventDefault();e.stopPropagation();
 if(b.dataset.busy)return;b.dataset.busy='1';
 var label=b.querySelector('span')||b;var old=label.textContent;
 label.textContent='Adding...';
 fetch('/cart/add.js',{method:'POST',headers:{'Content-Type':'application/json','Accept':'application/json'},body:JSON.stringify({items:[{id:Number(b.getAttribute('data-vid')),quantity:1}]})})
 .then(function(r){
  if(!r.ok)throw new Error('add failed');
  label.textContent='Added';b.classList.add('lb-add--done');refresh();if(window.LBConfetti){window.LBConfetti()}
  setTimeout(function(){label.textContent=old;b.classList.remove('lb-add--done');delete b.dataset.busy},1800);
 })
 .catch(function(){label.textContent='Try again';setTimeout(function(){label.textContent=old;delete b.dataset.busy},1800)});
},true);
})();
(function(){
var det,home,nextSib,moved=false;
function find(){
 if(det&&det.isConnected)return det;
 det=document.querySelector('[id*="__lb_details"]');
 if(det){home=det.parentElement;nextSib=det.nextElementSibling}
 return det;
}
function layout(){
 if(!/\/products\//.test(location.pathname))return;
 var d=find();if(!d)return;
 var media=document.querySelector('.product-information__media');
 if(!media)return;
 var wide=window.matchMedia('(min-width: 990px)').matches;
 if(wide&&!moved){media.appendChild(d);d.classList.add('lb-moved');moved=true}
 else if(!wide&&moved){if(home){if(nextSib&&nextSib.isConnected){home.insertBefore(d,nextSib)}else{home.appendChild(d)}}d.classList.remove('lb-moved');moved=false}
}
function boot(){layout();window.addEventListener('resize',function(){clearTimeout(window.__lbR);window.__lbR=setTimeout(layout,150)})}
if(document.readyState!=='loading'){boot()}else{document.addEventListener('DOMContentLoaded',boot)}
document.addEventListener('shopify:section:load',function(){moved=false;det=null;setTimeout(layout,60)});
})();